import React from "react";
import { AccountActionsSection } from "./AccountActionsSection";
import { ERROR, COLOR_LIGHT_RED, ACCOUNT_TEXTS } from "../../../constants";
export const DeleteAccountSection = ({ onDelete }: any) => (
  <AccountActionsSection
    onClick={onDelete}
    color={COLOR_LIGHT_RED}
    title={ACCOUNT_TEXTS.DELETE_ACCOUNT.TITLE}
    subTitle={ACCOUNT_TEXTS.DELETE_ACCOUNT.SUBTITLE}
    buttonLabel={ACCOUNT_TEXTS.DELETE_ACCOUNT.BUTTON_LABEL}
    buttonIcon={ACCOUNT_TEXTS.DELETE_ACCOUNT.ICON}
    colorType={ERROR}
  />
);
